
import { Theme, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import Tooltip from '../atoms/Tooltip';
import ArrowUpIcon from '../icons/ArrowUpIcon';
import { COLOR_RED } from '../styles/colors';
import { datetimeToDate } from '../services/converter';
import clsx from 'clsx';
import { PlayerNILValues } from '../types/PlayerNILValues';

interface NilValuesTooltipProps {
  playerNilValues: PlayerNILValues[];
  nilIndicatorClassName?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  nilTooltipWrapper: {
    display: 'inline-block',
    width: '20px',
  },
  nilHistoryIndicator: {
    height: '40px',
    position: 'relative',
    right: '10px',
    width: '40px',
  },
  nilListItem: {
    fontSize: '14px',

    '& span': {
      display: 'inline-block',
      textAlign: 'right',
      width: '70px',
    },
  },
  danger: {
    color: COLOR_RED,
  },
}));

export default function NilValuesTooltip(props: NilValuesTooltipProps) {
  const { playerNilValues, nilIndicatorClassName } = props;
  const sortedNilData = playerNilValues?.length
  ? [...playerNilValues].sort(
      (a, b) => new Date(b.on3Date).getTime() - new Date(a.on3Date).getTime()
    )
  : [];
  const classes = useStyles();

  const NilDataList = () => {
    return (
      <div>
        {sortedNilData.map((item, index) => {
          const prevValue = index >= 0 ? (sortedNilData[index]?.on3PublicNILValuation < sortedNilData[index + 1]?.on3PublicNILValuation) : false;

          return (
            <Typography key={index} className={clsx(classes.nilListItem, prevValue && classes.danger )}>
              <span>{item.on3PublicNILValuation.toLocaleString()}</span>: {!!item?.on3Date && datetimeToDate(item.on3Date)}
            </Typography>
          )
        })}
      </div>
    );
  };

  return (
    <div className={classes.nilTooltipWrapper}>
      <Tooltip title={NilDataList()}>
        <ArrowUpIcon className={clsx(classes.nilHistoryIndicator, nilIndicatorClassName)} />
      </Tooltip>
    </div>
  )
}
